<template>
  <div class="d-flex">
    <v-col
      cols="12"
      md="4"
    >
      <v-card outlined>
        <v-card-text>
          <div>Warehouse Information</div>
        </v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr>
                <th class="text-left">
                  Warehouse Name
                </th>
                <td>
                  {{ warehouse.name }}
                </td>
              </tr>
              <tr>
                <th class="text-left">
                  Email
                </th>
                <td>{{ warehouse.email }}</td>
              </tr>
              <tr>
                <th class="text-left">
                  Phone
                </th>
                <td>{{ warehouse.phone }}</td>
              </tr>
              <tr>
                <th class="text-left">
                  Location
                </th>
                <td>{{ warehouse.location }}</td>
              </tr>
              <tr>
                <th class="text-left">
                  Volume
                </th>
                <td>{{ warehouse.maxVolume }}</td>
              </tr>
              <tr>
                <th class="text-left">
                  Stocks
                </th>
                <td>{{ stocks.length }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="8"
    >
      <v-card outlined>
        <v-card-text>
          <v-btn @click="$router.back()">
            Back
          </v-btn>
        </v-card-text>
        <v-card-text>
          <div>Stocks list</div>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Order
                  </th>
                  <th>
                    Product
                  </th>
                  <th>
                    SKU
                  </th>
                  <th>
                    QTY
                  </th>
                  <th>
                    Sold
                  </th>
                  <th>
                    Cost
                  </th>
                  <th>
                    Price
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="stock in stocks"
                  :key="stock.id"
                >
                  <td>
                    <router-link
                      :to="{
                        name: 'PurchaseTransactionDetails',
                        params: { id: stock.id },
                      }"
                    >
                      #order
                    </router-link>
                  </td>
                  <td>
                    <router-link
                      :to="{
                        name: 'ProductDetail',
                        params: { id: stock.product.id },
                      }"
                    >
                      {{ stock.product.name }}
                    </router-link>
                  </td>
                  <td>{{ stock.product.sku }}</td>
                  <td>{{ stock.quantity }}</td>
                  <td>{{ stock.sold }}</td>
                  <td>{{ stock.cost | currency }}</td>
                  <td>{{ stock.price | currency }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
export default {
  data() {
    return {
      warehouse: {},
      stocks: {},
    };
  },
  mounted() {
    if (this.$route.params.id) {
      window.axios
        .get("/warehouse/" + this.$route.params.id)
        .then((response) => {
          this.$data.warehouse = response.data.warehouse;
          this.$data.stocks = response.data.stocks;
        });
    }
  },
};
</script>
